export const countTeamShots = (homeTeamId, visitingTeamId, shots) => {
  let homeShotCount = 0,
    visitorShotCount = 0

  shots.forEach((shot) => {
    if (shot.team_id === homeTeamId) {
      homeShotCount++
    } else if (shot.team_id === visitingTeamId) {
      visitorShotCount++
    }
  })

  return [homeShotCount, visitorShotCount]
}
